/* GreenEZ unified product card
   Handles: variant selection, image swap, price/availability sync, add-to-cart with Dawn cart drawer.
   Markup contract (see snippets/gez-product-card.liquid):
     <div class="gez-card" data-gez-card data-product-id data-variant-id>
       <div class="gez-card__media"><img data-gez-card-img src="..."></div>
       <div data-gez-card-price></div>
       <div data-gez-card-compare></div>
       <div data-gez-card-savings></div>
       <div class="gez-card__variants">
         <button data-gez-variant data-variant-id data-variant-price data-variant-compare data-variant-image data-variant-available>1 Qt</button>
       </div>
       <button data-gez-add type="button">Add to cart</button>
     </div>
*/
(function () {
  if (window.__gezProductCardInit) return;
  window.__gezProductCardInit = true;

  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  function selectVariant(card, btn) {
    const variants = card.querySelectorAll('[data-gez-variant]');
    variants.forEach((v) => v.classList.remove('is-active'));
    btn.classList.add('is-active');

    const variantId = btn.getAttribute('data-variant-id');
    const price = parseInt(btn.getAttribute('data-variant-price'), 10);
    const compare = parseInt(btn.getAttribute('data-variant-compare'), 10) || 0;
    const image = btn.getAttribute('data-variant-image');
    const available = btn.getAttribute('data-variant-available') === 'true';

    card.setAttribute('data-variant-id', variantId);

    const priceEl = card.querySelector('[data-gez-card-price]');
    if (priceEl) priceEl.textContent = formatMoney(price);

    const compareEl = card.querySelector('[data-gez-card-compare]');
    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    const savingsEl = card.querySelector('[data-gez-card-savings]');
    if (savingsEl) {
      if (compare > price) {
        const pct = Math.round(((compare - price) / compare) * 100);
        savingsEl.textContent = 'Save ' + pct + '%';
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    if (image) {
      const imgEl = card.querySelector('[data-gez-card-img]');
      if (imgEl) {
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('sizes');
        imgEl.src = image;
      }
    }

    const addBtn = card.querySelector('[data-gez-add]');
    if (addBtn) {
      addBtn.disabled = !available;
      const lbl = addBtn.querySelector('[data-gez-add-label]') || addBtn;
      if (!available) {
        lbl.textContent = 'Sold out';
      } else if (lbl.dataset.defaultLabel) {
        lbl.textContent = lbl.dataset.defaultLabel;
      }
    }
  }

  function addToCart(card) {
    const variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    const addBtn = card.querySelector('[data-gez-add]');
    const lbl = addBtn ? (addBtn.querySelector('[data-gez-add-label]') || addBtn) : null;
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      if (lbl && !lbl.dataset.defaultLabel) lbl.dataset.defaultLabel = lbl.textContent.trim();
      if (lbl) lbl.textContent = 'Adding...';
    }

    // Find Dawn's cart drawer / cart notification to ask for sections
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotif = document.querySelector('cart-notification');
    const sectionsTarget = cartDrawer || cartNotif;
    let sectionIds = [];
    if (sectionsTarget && typeof sectionsTarget.getSectionsToRender === 'function') {
      sectionIds = sectionsTarget.getSectionsToRender().map((s) => s.id);
    } else {
      sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    }
    if (sectionIds.indexOf('cart-icon-bubble') === -1) sectionIds.push('cart-icon-bubble');

    const variantIdInt = parseInt(variantId, 10);
    const rootUrl = window.Shopify.routes.root;
    const sectionsCsv = sectionIds.join(',');
    const sectionsUrl = window.location.pathname;

    // Normal /cart/add when the variant is not yet in the cart
    const doNormalAdd = () => fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantIdInt, quantity: 1 }],
        sections: sectionsCsv,
        sections_url: sectionsUrl,
      }),
    }).then((r) => r.json());

    // Consolidating add when the variant is already in the cart (possibly
    // split across lines by a BOGO / Buy-X-Get-Y cart transform).  Sum all
    // matching lines, zero the duplicates, set the primary paid line to
    // the new total — all atomically via /cart/update.js.
    const doConsolidatingAdd = (cart) => {
      const matching = (cart.items || []).filter((it) => it.variant_id === variantIdInt);
      if (matching.length === 0) return doNormalAdd();

      const currentTotal = matching.reduce((s, it) => s + it.quantity, 0);
      const newTotal = currentTotal + 1;

      // Prefer a paid line with no BOGO/gift hidden properties
      const primary = matching.find((it) => {
        const fp = it.final_line_price != null ? it.final_line_price : it.final_price;
        if (fp === 0) return false;
        const props = it.properties || {};
        return !Object.keys(props).some((k) =>
          /^_?(bogo|free.?gift|gift|discount|reward|auto.?add)/i.test(k)
        );
      }) || matching[0];

      const updates = {};
      matching.forEach((it) => {
        updates[it.key] = (it.key === primary.key) ? newTotal : 0;
      });

      return fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: sectionsCsv,
          sections_url: sectionsUrl,
        }),
      }).then((r) => r.json());
    };

    fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => doConsolidatingAdd(cart))
      .catch(() => doNormalAdd())
      .then((parsed) => {
        if (parsed.status) {
          // Error
          if (lbl) lbl.textContent = 'Try again';
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'gez-product-card',
              productVariantId: variantId,
              errors: parsed.errors || parsed.description,
              message: parsed.message,
            });
          }
          return;
        }

        // On the cart page, skip the drawer (renderContents opens it) and do full section refresh
        if (document.querySelector('.gez-cart') && window.__gezRefreshCart) {
          window.__gezRefreshCart();
        } else if (sectionsTarget && typeof sectionsTarget.renderContents === 'function') {
          try { sectionsTarget.renderContents(parsed); } catch (err) { /* Dawn drawer render edge cases — bubble still updates below */ }
        }

        // Always refresh the cart icon bubble (Dawn's renderContents doesn't always touch it)
        if (parsed.sections && parsed.sections['cart-icon-bubble']) {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const tmp = document.createElement('div');
            tmp.innerHTML = parsed.sections['cart-icon-bubble'];
            const fresh = tmp.querySelector('#cart-icon-bubble');
            bubble.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
          }
        }

        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'gez-product-card',
            productVariantId: variantId,
            cartData: parsed,
          });
        }

        if (lbl) lbl.textContent = 'Added to cart!';
        setTimeout(() => {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
          }
          if (lbl && lbl.dataset.defaultLabel) lbl.textContent = lbl.dataset.defaultLabel;
        }, 1800);
      })
      .catch(() => {
        if (lbl && lbl.dataset.defaultLabel) lbl.textContent = lbl.dataset.defaultLabel;
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        }
      });
  }

  function bindCard(card) {
    if (card.__gezBound) return;
    card.__gezBound = true;

    card.querySelectorAll('[data-gez-variant]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        selectVariant(card, btn);
      });
    });

    const sel = card.querySelector('[data-gez-variant-select]');
    if (sel) {
      sel.addEventListener('change', () => {
        const opt = sel.options[sel.selectedIndex];
        if (opt) selectVariant(card, opt);
      });
    }

    const addBtn = card.querySelector('[data-gez-add]');
    if (addBtn) {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart(card);
      });
    }
  }

  window.__gezBindCard = bindCard;

  function init() {
    document.querySelectorAll('[data-gez-card]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after section editor reloads
  document.addEventListener('shopify:section:load', init);
})();
